import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { DateTime } from 'luxon';
import { toDateTime } from '../../../utils/date-time';

@Pipe({ name: 'isFuture', pure: true })
export class AppIsFuture implements PipeTransform {
    transform(value: string | DateTime, format?: string): any {
        const instance = toDateTime(value);

        if (instance?.isValid) {
            return instance >= DateTime.local();
        }

        return false;
    }
}
